var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCommentStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8757 2.94141H4.1242C2.82103 2.94141 1.76465 4.01329 1.76465 5.33559V11.0676C1.76465 12.3899 2.82103 13.4618 4.1242 13.4618H6.22805V17.0589L10.3532 13.4618H15.8757C17.1789 13.4618 18.2352 12.3899 18.2352 11.0676V5.33559C18.2352 4.01329 17.1789 2.94141 15.8757 2.94141Z",
    fill: "#F0665D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0222 4.40625L11.1401 6.78878L13.7185 7.1312L11.8308 8.94614L12.3066 11.5403L10.0222 10.2796L7.73776 11.5403L8.21347 8.94614L6.32581 7.1312L8.90434 6.78878L10.0222 4.40625Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCommentStar);
export default __webpack_public_path__ + "static/media/IconCommentStar.12bffc2e8324a4bfae843e0527c859e5.svg";
export { ForwardRef as ReactComponent };